import type { ReactNode } from 'react';
import { Icon, type IconName } from './ui/Icon';

interface Props {
  icon?: IconName;
  title: string;
  body?: string;
  action?: ReactNode;
  /** `1` when the empty state IS the page (404), `2` when it sits under one. */
  headingLevel?: 1 | 2;
}

/** Mandatory state in any data view — never leave a blank screen. */
export function EmptyState({ icon, title, body, action, headingLevel = 2 }: Props) {
  const Heading = headingLevel === 1 ? 'h1' : 'h2';
  return (
    <div className="flex flex-col items-center rounded-token border border-dashed border-border bg-surface-2 px-4 py-10 text-center sm:py-14">
      {icon && (
        <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-accent-soft text-accent">
          <Icon name={icon} className="h-6 w-6" />
        </span>
      )}
      <Heading className="text-lg font-semibold text-fg">{title}</Heading>
      {body && <p className="mt-2 max-w-prose text-sm text-muted">{body}</p>}
      {action && <div className="mt-6">{action}</div>}
    </div>
  );
}
